/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для одной категории в каталоге
   */
  app.CategoryView = app.View.extend({
    
    // Обработчики пользовательских событий
    events: {
      'click .js-ctl-fav': 'toggleInFavoritesCategory',
      'click .foldable_control': 'toggleSubCategory'
    },
    access: null,
    
    run: function () {
      this.access = {
        canCreateWishCategory: false,
        canDestroyWishCategory: false
      };
      
      this.wishBtn = this.$('.js-ctl-fav');
      this.categoryId = this.wishBtn.attr('cid');
      this.categoryOrder = parseInt(this.$el.data('category-order'), 10);
      this.url = this.$('h2 a').attr('href');
      this.$foldable = this.$('.foldable');
      
      // обновляем статус для категорий, добавленных в избранное
      if (app.wishCategories.get(this.categoryId) !== undefined) {
        this.access.canDestroyWishCategory = true;
        this.wishCategory = app.wishCategories.get(this.categoryId);
        this.wishBtn.toggleClass('with-icon_fav-not-active with-icon_fav-active');
        this.wishBtn.tooltip('option', 'disabled', true);
      } else {
        this.access.canCreateWishCategory = true;
      }
      
      this.model = new app.CategorySecond({id: this.categoryId, response: null});
      this.model.on('change:response', this.render, this);
    },
    
    /**
     * Добавляет или удалаяет категорию из избранного
     */
    toggleInFavoritesCategory: function () {
      var self = this;
      if (app.wishCategories.get(this.categoryId) === undefined) {
        if (this.access.canCreateWishCategory) {
          this.access.canCreateWishCategory = false;
          this.wishCategory = app.wishCategories.create({
            category_id: this.categoryId
          }, {
            wait: true,
            success: function () {
              self.access.canDestroyWishCategory = true;
              self.wishBtn.toggleClass('with-icon_fav-not-active with-icon_fav-active');
              self.wishBtn.tooltip('option', 'disabled', true);
            },
            method: 'POST'
          });
        }
      } else {
        if (this.access.canDestroyWishCategory) {
          this.access.canDestroyWishCategory = false;
          this.wishCategory.destroy({
            url: this.wishCategory.url + this.wishCategory.get('id') + '/',
            success: function () {
              self.access.canCreateWishCategory = true;
              self.wishBtn.toggleClass('with-icon_fav-not-active with-icon_fav-active');
              self.wishBtn.tooltip('option', 'disabled', false);
            }
          });
        }
      }
    },
    
    /**
     * Раскрытие категорий, содержимое которых будет подгруженао ajax'ом.
     * @todo когда появится прелоадер, добавить его для ожидания получения контента.
     */
    toggleSubCategory: function () {
      //порядковый номер последней статичной категории 2 уровня на странице 1 уровня.
      var VISIBLE_CATEGORY_KEY = 1;
      
      if (this.categoryOrder > VISIBLE_CATEGORY_KEY && !this.model.has('response')) {
        this.model.fetch({
          data: {
            'categoryId': this.categoryId,
            'key': this.categoryOrder,
            'currency': app.helpers.UrlHelper.getUrlParameter('currency') ? app.helpers.UrlHelper.getUrlParameter('currency') : ''
          },
          success: function (model, response) {
            model.set({'response': response});
          }
        });
      }
    },
    
    /**
     * Рендерим блок с категориями.
     */
    render: function () {
      this.$foldable.html(this.model.get('response'));
      this.$el.find('.product').each(function () {
        new app.ItemView({'el': $(this), 'qtyView': 'ItemQtyView'});
      });
      new app.TabsListView({'el': this.$foldable.find('.sl-tabs')});
    }
  });
})(jQuery);


}.call(window));